import {Card, FlexRow, styled} from "@reside/ui";
import {AdminLayout} from "../../atoms/admin-layout";

/** Matches `AdminLayout` `LayoutContent` max-width. */
export const ADMIN_CONTENT_MAX_WIDTH = 1280;

/** Title row: page title on the left, actions on the right. */
export const HubAndSpokePageHeader = styled(FlexRow)`
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${({theme}) => theme.space[4]}px;
  width: 100%;
  margin-bottom: ${({theme}) => theme.space[5]}px;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: ${({theme}) => theme.space[4]}px;
`;

/** Compact filter (e.g. template select) rendered next to header actions. */
export const HeaderFilter = styled.div`
  width: 320px;
  max-width: 100%;

  label {
    margin: 0;
  }
`;

/** Keeps wide tables inside the content column, scrolling only when needed. */
export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;

  .list-table {
    min-width: 100%;
  }

  td p {
    margin: 0;
  }
`;

export const FormCardWrapper = styled(Card)`
  padding: ${({theme}) => `${theme.space[5]}px ${theme.space[6]}px`};
`;

export const FormSection = styled.section`
  padding-bottom: ${({theme}) => theme.space[5]}px;
  margin-bottom: ${({theme}) => theme.space[5]}px;
  border-bottom: ${({theme}) => `1px solid ${theme.color.gray10}`};

  &:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
  }
`;

export const FormSectionTitle = styled.h3`
  margin: 0 0 ${({theme}) => theme.space[2]}px;
  font-size: ${({theme}) => theme.fontSize[3]}px;
  font-weight: 500;
  color: ${({theme}) => theme.color.darkBlue100};
`;

export const FormSectionHint = styled.p`
  margin: 0 0 ${({theme}) => theme.space[3]}px;
  font-size: ${({theme}) => theme.fontSize[2]}px;
  color: ${({theme}) => theme.color.gray150};
`;

/** Lays fields out in two columns on wide screens, one on narrow ones. */
export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: ${({theme}) => theme.space[6]}px;

  @media (min-width: ${({theme}) => theme.breakpoint.md}px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const FormFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${({theme}) => theme.space[4]}px;
  padding-top: ${({theme}) => theme.space[5]}px;
  border-top: ${({theme}) => `1px solid ${theme.color.gray10}`};
`;

export const FooterActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({theme}) => theme.space[3]}px;
  margin-left: auto;
`;

export const MissingFieldsHint = styled.span`
  font-size: ${({theme}) => theme.fontSize[2]}px;
  color: ${({theme}) => theme.color.gray150};
`;

export const TemplateFieldRow = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-end;
  gap: ${({theme}) => theme.space[4]}px;
  margin: ${({theme}) => theme.space[2]}px 0;

  label {
    width: 100%;
  }
`;

export const TemplateFieldCard = styled.div`
  border-bottom: ${({theme}) => `1px solid ${theme.color.gray10}`};
  padding: ${({theme}) => theme.space[4]}px 0;

  &:last-of-type {
    border-bottom: none;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({theme}) => theme.space[3]}px;
`;

export const Layout = styled(AdminLayout)`
  padding-top: 80px;
`;
